import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { CheckCircle2, UserPlus, Users, Tag, TagIcon, RotateCcw, AlertTriangle, Ban } from "lucide-react";

/**
 * Dialog s podrobnim poročilom Lisjak sinhronizacije.
 * props.data = { members_created, members_pending_update, vezice_new, vezice_unassigned, vezice_orphan_created, vezice_pending, pending }
 */
const LisjakSyncReportDialog = ({ open, onClose, data }) => {
  if (!data) return null;

  const items = [
    { key: "members_created", icon: UserPlus, label: "Novi člani", value: data.members_created || 0, tone: "emerald", desc: "avtomatsko dodani iz Lisjaka" },
    { key: "members_pending_update", icon: Users, label: "Spremembe članov", value: data.members_pending_update || 0, tone: "amber", desc: "čakajo na vaše potrjevanje" },
    { key: "vezice_new", icon: Tag, label: "Nove vezice", value: data.vezice_new || 0, tone: "emerald", desc: "dodeljene članom" },
    { key: "vezice_orphan_created", icon: TagIcon, label: "Nove proste vezice", value: data.vezice_orphan_created || 0, tone: "sky", desc: "LD prejela nov razpon" },
    { key: "vezice_unassigned", icon: RotateCcw, label: "Sproščene vezice", value: data.vezice_unassigned || 0, tone: "slate", desc: "člani so vrnili" },
    { key: "vezice_pending", icon: AlertTriangle, label: "Vezice v konfliktu", value: data.vezice_pending || 0, tone: "amber", desc: "čakajo na potrjevanje" },
    { key: "vezice_uporabljene", icon: Ban, label: "Uporabljene vezice", value: data.vezice_uporabljene || 0, tone: "red", desc: "uporabljene pri odvzemu (Lisjak)" },
  ];

  const totalPending = (data.members_pending_update || 0) + (data.vezice_pending || 0);

  const toneClasses = {
    emerald: "bg-emerald-50 dark:bg-emerald-950/30 text-emerald-800 dark:text-emerald-200 border-emerald-200 dark:border-emerald-800",
    amber: "bg-amber-50 dark:bg-amber-950/30 text-amber-900 dark:text-amber-100 border-amber-200 dark:border-amber-800",
    sky: "bg-sky-50 dark:bg-sky-950/30 text-sky-800 dark:text-sky-200 border-sky-200 dark:border-sky-800",
    slate: "bg-slate-50 dark:bg-slate-900/60 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700",
    red: "bg-red-50 dark:bg-red-950/30 text-red-800 dark:text-red-200 border-red-200 dark:border-red-800",
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid="lisjak-sync-report-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5 text-emerald-600" />
            Sinhronizacija z Lisjakom zaključena
          </DialogTitle>
          <DialogDescription>
            Rezultat trenutnega uvoza – podatki so sinhronizirani z LZS Lisjak.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-2 mt-2">
          {items.map(({ key, icon: Icon, label, value, tone, desc }) => (
            <div
              key={key}
              className={`rounded-lg border p-2.5 ${toneClasses[tone]}`}
              data-testid={`lisjak-sync-stat-${key}`}
            >
              <div className="flex items-center gap-1.5">
                <Icon className="h-3.5 w-3.5" />
                <span className="text-xs font-medium">{label}</span>
              </div>
              <div className="text-2xl font-bold mt-1 leading-none">{value}</div>
              <div className="text-[10px] opacity-70 mt-0.5">{desc}</div>
            </div>
          ))}
        </div>

        {totalPending > 0 && (
          <div className="mt-3 p-3 rounded-md bg-amber-50 dark:bg-amber-950/40 border border-amber-300 dark:border-amber-800 text-sm text-amber-900 dark:text-amber-100">
            <div className="flex items-center gap-1.5 font-medium">
              <AlertTriangle className="h-4 w-4" />
              Čaka vas {totalPending} sprememb za potrjevanje
            </div>
            <div className="text-xs mt-1 opacity-80">
              Preglejte in potrdite jih v <b>Upravljanje → Lisjak → Čakajoče spremembe</b>.
            </div>
          </div>
        )}

        <DialogFooter>
          <Button onClick={onClose} data-testid="lisjak-sync-report-close">V redu</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LisjakSyncReportDialog;
